import axios from 'axios';
import apiConfig from '../api.config';

export default function upsellSendEmailToGuestApprovedRequest({ hotelSlug, pmsId, tags }) {
  const {
    upsellHost,
    URIs: { upsellSendEmailToGuestApproved },
  } = apiConfig;

  // workaround: Guestlink does not support htts rigth now on PROD
  const uri = `${upsellHost}${upsellSendEmailToGuestApproved}`;

  return axios
    .post(
      uri,
      JSON.stringify({ hotelSlug, pmsId, schedule: 'guest-accepted', options: { tags } }),
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    )
    .then(res => {
      return res.data;
    });
}
